import * as React from 'react';

import { ShippingLogo } from '../logo/shipping-logo';
import { ShippingOptionLogoWrapper } from '../logo/shipping-option-logo';

type OwnProps = {
  carrierLogos: string[];
};

export const HorizontalLogoDeck: React.FC<OwnProps> = ({ carrierLogos }) => {
  const elements = carrierLogos.map((carrierLogo: string) => {
    return (
      <div key={carrierLogo} css={{ width: '22px' }}>
        <ShippingOptionLogoWrapper size={34}>
          <ShippingLogo shippingMethod={carrierLogo} size={30} />
        </ShippingOptionLogoWrapper>
      </div>
    );
  });

  return <div css={{ position: 'relative', display: 'flex' }}>{elements}</div>;
};
